<template>
  <div class="col-xl-3 col-lg-12 theiaStickySidebar">
    <!-- Settings Sidebar -->
    <div class="card">
      <div class="card-body">
        <div class="settings-sidebar">
          <h4 class="fw-semibold mb-3">Individual</h4>
          <div class="list-group list-group-flush settings-sidebar">
            <router-link to="/leads-individual/initial-info" class="fw-medium">Initial Info</router-link>
            <router-link to="/leads-individual/basic-info" class="fw-medium">Basic Info</router-link>
            <router-link to="/leads-individual/personal-info" class="fw-medium">Personal Info</router-link>
            <router-link to="/leads-individual/communication-info" class="fw-medium">Communication Info</router-link>
            <router-link to="/leads-individual/service-info" class="fw-medium">Job/Service Info</router-link>
   
          </div>
        </div>
      </div>
    </div>
    <!-- /Settings Sidebar -->
  </div>
</template>
